import classNames from "classnames";
import values from "lodash/values";
import PropTypes from "prop-types";
import React, { Component } from "react";

import ChatActions from "../../actions/ChatActions";
import RatingSystemType from "../../constants/ChatRatingSystemTypes";

import RatingSystemFiveFaces from "./ratingSystems/RatingSystemFiveFaces";
import RatingSystemFiveStars from "./ratingSystems/RatingSystemFiveStars";
import RatingSystemFourFaces from "./ratingSystems/RatingSystemFourFaces";
import RatingSystemThreeFaces from "./ratingSystems/RatingSystemThreeFaces";
import RatingSystemTwoFaces from "./ratingSystems/RatingSystemTwoFaces";
import Loader from "./Loader";

class ToolbarRate extends Component {
    constructor() {
        super();

        this.onToggleRateToolbar = this.onToggleRateToolbar.bind(this);
        this.rateResponse = this.rateResponse.bind(this);
    }

    componentDidMount() {
        this.props.setOffsetBottomOfMessageList();
    }

    componentWillUnmount() {
        /*
         * setTimeout is needed to make sure ToolbarRate is not in DOM anymore
         * when computing new bottom offset
         */
        setTimeout(this.props.setOffsetBottomOfMessageList, 80);
    }

    onToggleRateToolbar() {
        ChatActions.responseToggleRateToolbar();
    }

    rateResponse(happiness) {
        const { question, response } = this.props;

        ChatActions.responseRate({
            newHappiness: happiness,
            prevHappiness: response.happiness,
            questionUuid: question.uuid,
            responseId: response.id,
        });
    }

    render() {
        const { ratingSystem, response } = this.props;
        const toolbarClasses = classNames({
            "toolbar-container": true,
            "toolbar-rate-container": true,
            "is-in-progress": response.ratingInProgress,
        });

        let ratingSystemComponent;
        switch (ratingSystem) {
            case RatingSystemType.twoFaces:
                ratingSystemComponent = <RatingSystemTwoFaces onRate={this.rateResponse} />;
                break;
            case RatingSystemType.threeFaces:
                ratingSystemComponent = <RatingSystemThreeFaces onRate={this.rateResponse} />;
                break;
            case RatingSystemType.fourFacesHappyToSad:
                ratingSystemComponent = <RatingSystemFourFaces onRate={this.rateResponse} order="positiveToNegative" />;
                break;
            case RatingSystemType.fourFacesSadToHappy:
                ratingSystemComponent = <RatingSystemFourFaces onRate={this.rateResponse} order="negativeToPositive" />;
                break;
            case RatingSystemType.fiveFacesHappyToSad:
                ratingSystemComponent = <RatingSystemFiveFaces onRate={this.rateResponse} order="positiveToNegative" />;
                break;
            case RatingSystemType.fiveFacesSadToHappy:
                ratingSystemComponent = <RatingSystemFiveFaces onRate={this.rateResponse} order="negativeToPositive" />;
                break;
            case RatingSystemType.fiveStars:
                ratingSystemComponent = (
                    <RatingSystemFiveStars
                        customerHappiness={response.customerHappiness}
                        onRate={this.rateResponse}
                        happiness={response.happiness}
                    />
                );
                break;
            default:
                ratingSystemComponent = <RatingSystemThreeFaces onRate={this.rateResponse} />;
        }

        const cancelBtnLabel = i18n.t("rtm.button.cancel")

        return (
            <div className={toolbarClasses}>
                <Loader isLoading={response.ratingInProgress}>{ratingSystemComponent}</Loader>
                <button name={cancelBtnLabel} className="toolbar-btn" onClick={this.onToggleRateToolbar}>
                    <span className="btn-content-wrapper">{cancelBtnLabel}</span>
                </button>
            </div>
        );
    }
}

ToolbarRate.propTypes = {
    question: PropTypes.object.isRequired,
    ratingSystem: PropTypes.oneOf(values(RatingSystemType)).isRequired,
    response: PropTypes.object.isRequired,
    setOffsetBottomOfMessageList: PropTypes.func.isRequired,
};

export default ToolbarRate;
